import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

import esriConfig from "@arcgis/core/config";
import {addProxyRule} from "@arcgis/core/core/urlUtils";


esriConfig.request.trustedServers.push(environment.api_host);
addProxyRule({
  urlPrefix: 'gis.epa.guam.gov',
  proxyUrl: environment.proxyUrl
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
